/**
 * This code was generated by Builder.io.
 */
import React from "react";
import styles from "./PremiumReportList.module.css";

interface TabSectionProps {
  activeTab: string;
  onTabClick: (tabName: string) => void;
}

const TabSection: React.FC<TabSectionProps> = ({ activeTab, onTabClick }) => {
  return (
    <div className={styles.div16}>
      <div className={styles.div17}>
        <div className={styles.tabs}>
          <div
            className={`${styles.tabItem} ${
              activeTab === "premium report" ? styles.tabItem2 : ""
            }`}
            onClick={() => onTabClick("premium report")}
          >
            <div className={styles.frame}>premium report</div>
            <div
              className={
                activeTab === "premium report"
                  ? styles.divider2
                  : styles.divider
              }
            />
          </div>
          <div
            className={`${styles.tabItem} ${
              activeTab === "premium adjustment" ? styles.tabItem2 : ""
            }`}
            onClick={() => onTabClick("premium adjustment")}
          >
            <div className={styles.frame}>premium adjustment</div>
            <div
              className={
                activeTab === "premium adjustment"
                  ? styles.divider2
                  : styles.divider
              }
            />
          </div>
          <div
            className={`${styles.tabItem3} ${
              activeTab === "single premium certificate return"
                ? styles.tabItem2
                : ""
            }`}
            onClick={() => onTabClick("single premium certificate return")}
          >
            <div className={styles.frame}>
              single premium certificate return
            </div>
            <div
              className={
                activeTab === "single premium certificate return"
                  ? styles.divider2
                  : styles.divider
              }
            />
          </div>
          <div
            className={`${styles.tabItem4} ${
              activeTab === "Create New" ? styles.tabItem2 : ""
            }`}
            onClick={() => onTabClick("Create New")}
          >
            <div className={styles.frame}>Create New</div>
            <div
              className={
                activeTab === "Create New" ? styles.divider2 : styles.divider3
              }
            />
           {/* <PremiumSelection/> */}
          </div>
        </div>
        <div className={styles.div18} />
      </div>
    </div>
  );
};

export default TabSection;
